import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../store/reportStore'
import { isNullOrUndefined } from '../../store/storeFunctions';
import Money from '../common/moneyComponent';
import FixedTable from '../layoutItems/fixedTable';
import OldStyleSection from '../common/oldStyleSection';
import ExcelExportButon from '../common/excelExportButton';


class FinStatementsData extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (isNullOrUndefined(this.props.data) || !this.props.data.hasAnyData ? null : this.renderContent(this.props.data));
    }

    renderContent = (data) => {
        let years = data.years; 
        return (
            <>
                <OldStyleSection isOpen isBold hasData
                    name={this.props.translate('Report.SimpleAccounting.SectionName')}>
                    {data.hasIncomeExpenses ? this.renderTable(data.incomeExpenses, years, "IncomeExpenses") : null}
                    {data.hasAssetsLiabilities ? this.renderTable(data.assetsLiabilities, years, "AssetsLiabilities") : null}
                </OldStyleSection>
                <ExcelExportButon link="simple-accounting" entityId={this.props.id} ascending={this.props.ascending }/>
            </>
        );
    }

    renderTable = (section, years, id) => {
        const filteredYears = years.filter(f => section.some((e) => !isNullOrUndefined(e.values[f])));
        return (
            <>
                <table id={"simpleAccounting" + id} className="table table-report-section  fin-stmt-table-first only-full-width">
                    <thead>
                        <tr>
                            <th className="fin-stmt-type-1" colSpan={2 + filteredYears.length}><Translate id={"Report.SimpleAccounting." + id} /></th>
                        </tr>
                        <tr>
                            <th width="40%" className="fin-stmt-type-2"><Translate id="Report.SimpleAccounting.Item" /></th>
                            <th width="15%" className="fin-stmt-type-2" />
                            {filteredYears.map(y => <th key={y} className="fin-stmt-type-2 align-right">{y}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {section.map((s, i) =>
                            <tr key={i} className={"fin-stmt-row" + (s.level < 4 ? " level-" + s.level : "")}>
                                <td className="fin-stmt-desc"><Translate id={s.description} /></td>
                                <td className="fin-stmt-type-2">{s.code}</td>
                                {filteredYears.map(y =>
                                    <td style={{ textAlign: "right" }} key={y} className="fin-stmt-value-2">{this.getInterval(s.values[y].min, s.values[y].max)}</td>)}
                            </tr>
                        )}
                    </tbody>
                </table>
                <FixedTable onlyMobile data={this.prepareFixedData(id, filteredYears, section, id === "IncomeExpenses")} columnWidth={150}
                    columnCount={filteredYears.length + 2} fixedRowCount={2}
                />
            </>
        );
    }

    prepareFixedData = (id, years, section, first = false) => {
        let final = [];
        let headers = [this.props.translate(`Report.SimpleAccounting.${id}`)];
        headers.push(<div />);
        years.map(y => {
            headers.push(<React.Fragment key={y} />)
        });

        final.push(headers);
        let yearsArray = [this.props.translate(`Report.SimpleAccounting.Item`), <React.Fragment />];
        years.map(y => yearsArray.push(<React.Fragment key={y}>{y}</React.Fragment>));
        final.push(yearsArray);

        section.map((item, i) => {
            let row = { data: [], className: item.level < 4 ? `fin-stmt-row level-${item.level}` : undefined, forcedClass: item.level < 3 };
            row.data.push(this.props.translate(item.description));
            row.data.push(item.code);
            years.forEach(y => row.data.push(isNullOrUndefined(item.values[y]) ? "" : this.getInterval(item.values[y].min, item.values[y].max)));
            final.push(row);
        });
        return final;
    }

    getInterval = (min, max) => {
        if (!isNullOrUndefined(min) && !isNullOrUndefined(max) && min < 0 && max < 0)
            return <><Money value={max} fractionDigits={0} /> {this.props.translate("Report.SimpleAccounting.To")} <Money value={min} fractionDigits={0} /></>
        if (isNullOrUndefined(min) && !isNullOrUndefined(max) && max <= 0)
            return <>{max === 0 ? "< 0" : <><Money value={max} fractionDigits={0} /> {this.props.translate("Report.SimpleAccounting.AndLess")}</>}</>;
        if (isNullOrUndefined(max) && !isNullOrUndefined(min) && min >= 0)
            return <><Money value={min} fractionDigits={0}/> {this.props.translate("Report.SimpleAccounting.AndMore")}</>;
        if (!isNullOrUndefined(min) && !isNullOrUndefined(max) && min == max)
            return <Money value={min} fractionDigits={0}/>;
        return <><Money value={min} fractionDigits={0} /> - <Money value={max} fractionDigits={0} /></>;
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(FinStatementsData));